<template>
    <div style="text-align: left">
        <div class="herd">
            <div class="list">统计商品</div>
            <el-button style="margin-left:20px" type="primary" plain @click="returnPage">返 回</el-button>
        </div>

        <div class="content">
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%;" tooltip-effect="dark" :cell-style="{}">
                    <!-- <el-table-column type="selection" width="55">
                    </el-table-column> -->
                    <el-table-column type="index" width="50" label="#" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="goodsName" label="商品名称" width="270" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column prop="goodsType" label="商品来源" width="200" align="center" header-align="center"
                        max-width="500px">
                    </el-table-column>
                    <el-table-column prop="schoolName" label="学校名称" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column prop="quantity" label="销售数量(件)" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="totalSales" label="销售总额(元)" width="200" header-align="center" align="center">
                    </el-table-column>

                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <!-- <el-button @click="export2Excel(scope.row)" type="text" size="small">导出数据</el-button> -->
                            <el-button type="text" size="small" @click="openDeriveGoods(scope.row)">导出发货明细表</el-button>
                            <el-button type="text" size="small" @click="editorChild(scope.row)">详情</el-button>
                            <!-- <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="info.pageNum"
                    layout="prev, pager, next, jumper" :total="totalPage" :page-size="10">
                </el-pagination>
            </div> -->
        </div>

        <!-- 发货明细表 -->
        <el-dialog title="发货明细表" :visible.sync="dialogRefundExpoit" width="400px">
            <el-form :model="infoExpoit" ref="rulesExpoit" label-width="100px" class="demo-ruleForm">
                <el-form-item label="学校名称" prop="name">
                    <el-input v-model="infoExpoit.name" style="width: 220px;" disabled></el-input>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.startTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.endTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogRefundExpoit = false">取 消</el-button>
                <el-button type="primary" @click="deriveGoods">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from '../utils/request';
import axios from 'axios';
import exportUrl from '../Api/exportUrl'
export default {

    data() {
        return {
            exportUrl,
            dialogRefundExpoit: false,
            infoExpoit: {
                name: '',
                startTime: '',
                endTime: ''
            },
            rulesExpoit: {
                startTime: [
                    { required: true, message: '请输入开始时间', trigger: 'change' },
                ],
                endTime: [
                    { required: true, message: '请输入结束时间', trigger: 'change' },
                ],
            },
            // 查询参数
            info: {
                isPage: true,
                pageSize: 10,
                pageNum: 1,
                batchId: ''
            },
            dataList: [
                { 'username': '小明', 'phone': '123456', 'gender': '男', 'age': '8' },
                { 'username': '小红', 'phone': '123456', 'gender': '男', 'age': '8' },
                { 'username': '小丽', 'phone': '123456', 'gender': '男', 'age': '8' },
            ],
            // 批次列表
            tableData: [],
            // 总条数
            totalPage: 0,
            schoolId: '',
            // 导出参数
            item: {}
        };
    },
    created() {
        this.info.batchId = this.$route.query.id
        this.schoolId = this.$route.query.schoolId
        this.getBatchGoods()
    },
    mounted() {

    },

    methods: {
        // 返回上一页
        returnPage() {
            this.$router.go(-1)
        },
        // 查询批次批次商品
        async getBatchGoods() {
            const res = await request({
                method: 'GET',
                url: `admin/statistical/analysis/getStatisticsBatchAllGoods?batchId=${this.info.batchId}`,
            })
            if (res.code === '200') {
                this.tableData = res.data
            } else {
                this.$message.error(res.message)
            }
        },

        // 分页
        handleCurrentChange() {
        },
        // 详情
        editorChild(val) {
            console.log(this.schoolId);
            this.$router.push({ name: 'salesStatistics', query: { goodsId: val.goodsId, batchId: this.info.batchId, schoolId: this.schoolId } })
            // this.$router.push({ path: '/statisticsBacthGoods' , query: { id: val.id }});
        },
        // 计算销售总额
        //  totalCalculation(item) {
        //     return ((Number(item.ownGoods) * 100) - (Number(item.transportation) * 100)) / 100
        // },

        // 获取导出参数
        openDeriveGoods(val) {
            this.dialogRefundExpoit = true
            if (this.$refs['rulesExpoit'] !== undefined) {
                this.$refs['rulesExpoit'].resetFields();
            }
            this.infoExpoit.name = ''
            this.infoExpoit.name = val.goodsName
            this.item = {}
            this.item = val
        },
        // 导出
        deriveGoods() {
            let val = this.item
            this.$refs['rulesExpoit'].validate((valid) => {
                if (valid) {
                    axios({
                        method: 'POST',
                        url: exportUrl + 'statistical/analysis/export/batch/goods',
                        headers: {
                            'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        data: {
                            batchId: this.info.batchId,
                            goodsId: val.goodsId,
                            goodsModel: val.goodsModel,
                            goodsName: val.goodsName,
                            startTime: this.infoExpoit.startTime,
                            endTime: this.infoExpoit.endTime
                        },
                        responseType: 'blob'
                    }).then((res) => {
                        this.dialogRefundExpoit = false
                        const temp = res.headers['content-disposition'].split(";")[1].split("filename=")[1];
                        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // res就是接口返回的文件流了
                        let objectUrl = URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.download = decodeURIComponent(temp)  //后缀名一定要写对，不然会导致文件损坏，打不开
                        a.href = objectUrl
                        a.click()
                        a.remove()


                    }).catch(error => {
                        this.dialogRefundExpoit = false
                        console.log(error);
                    });
                } else {
                    return false;
                }
            });

        }
    },

};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.gross-container {
    width: 300px;
    height: 100px;
    background-color: #000;
    text-align: center;
    padding: 20px 0;
    color: #fff;
}

.condition {
    display: flex;
    line-height: 30px;
}

.herd {
    display: flex;
    justify-content: space-between;
}

.block {
    text-align: right;
    background-color: #fff;
}

// .global-table-box{
//     height: 200px;
//     overflow: hidden;
// }

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>